import { z } from 'zod';

/**
 * Catálogo editable de cuerpos clínicos de consentimiento informado.
 *
 * Cada entrada corresponde a un código CUPS (o variante por médico) y contiene
 * el texto explicativo que se imprime en la sección del procedimiento dentro
 * del PDF unificado. El admin edita este texto desde /admin/consentimientos.
 */

export const ConsentBodySchema = z.object({
  cups: z.string().min(1).max(20),
  nombre: z.string().min(1).max(200),
  body: z.string().min(20).max(50_000),
  archivoOriginal: z.string().nullable(),
  updatedAt: z.string().datetime(),
  updatedBy: z.string().nullable(),
});
export type ConsentBody = z.infer<typeof ConsentBodySchema>;

export const ConsentBodyListSchema = z.object({
  items: z.array(ConsentBodySchema),
});
export type ConsentBodyList = z.infer<typeof ConsentBodyListSchema>;

export const UpdateConsentBodySchema = z.object({
  body: z
    .string()
    .min(20, 'El cuerpo debe tener al menos 20 caracteres')
    .max(50_000, 'El cuerpo no puede exceder 50.000 caracteres'),
});
export type UpdateConsentBodyInput = z.infer<typeof UpdateConsentBodySchema>;
